import type { PatientWithAppointment } from "@/Modules/Calendars/Models/Domain";

import { get as getPatients } from "@/Services/TherapyApi/Patients";
import PatientTransformer from "@/Modules/Transformers/Patient";

import useCalendarsStore from "../Store";

const fetchPatientsActionHandler = async (): Promise<PatientWithAppointment[]> => {
  const calendarsStore = useCalendarsStore();

  const patients = await getPatients();

  calendarsStore.patients = patients.map(PatientTransformer.toDomain);

  return calendarsStore.patients;
};

export default fetchPatientsActionHandler;
